import React from 'react';
import styled from '@emotion/styled';
import { useT } from 'client/i18n/hooks/useT';
import {
  ListHeader,
  ListItem,
  Title,
  DualColumns,
  List,
  ListSubHeader,
} from '../../../../components/MarketingPagesShared/DualColumnList';
import { MarketingSection } from '../../../../components/MarketingPagesShared/styles';

const GetStartedListItem = styled(ListItem)`
  margin: 0 0 32px 0;
  padding: 0 0 12px 0;
`;

export function GetStarted() {
  const t = useT();
  return (
    <MarketingSection>
      <DualColumns>
        <Title>
          {t(
            'WordpressScreen.GetStarted.Title',
            'Getting Started',
            'The title on the wordpress marketing screen when the user is getting started'
          )}
        </Title>
        <List>
          <GetStartedListItem>
            <ListSubHeader>
              {t(
                'WordpressScreen.GetStarted.StepOne.Header',
                'Step 1',
                'The header on the wordpress marketing screen when the user is getting started for step one'
              )}
            </ListSubHeader>
            <ListHeader>
              {t(
                'WordpressScreen.GetStarted.StepOne.Body',
                'Create an account and connect your blog',
                'The body on the wordpress marketing screen when the user is getting started for step one'
              )}
            </ListHeader>
          </GetStartedListItem>
          <GetStartedListItem>
            <ListSubHeader>
              {t(
                'WordpressScreen.GetStarted.StepTwo.Header',
                'Step 2',
                'The header on the wordpress marketing screen when the user is getting started for step two'
              )}
            </ListSubHeader>
            <ListHeader>
              {t(
                'WordpressScreen.GetStarted.StepTwo.Body',
                'Record or convert posts to audio',
                'The body on the wordpress marketing screen when the user is getting started for step two'
              )}
            </ListHeader>
          </GetStartedListItem>
          <GetStartedListItem>
            <ListSubHeader>
              {t(
                'WordpressScreen.GetStarted.StepThree.Header',
                'Step 3',
                'The header on the wordpress marketing screen when the user is getting started for step three'
              )}
            </ListSubHeader>
            <ListHeader>
              {t(
                'WordpressScreen.GetStarted.StepThree.Body',
                'Distribute your podcast everywhere',
                'The body on the wordpress marketing screen when the user is getting started for step three'
              )}
            </ListHeader>
          </GetStartedListItem>
        </List>
      </DualColumns>
    </MarketingSection>
  );
}
